import Vue from 'vue';
export default Vue.extend({
    data: function () {
        return {};
    },
    props: {
        successData: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    methods: {
        toSelectNotice: function () {
            this.$emit('return-select-notice');
        },
    },
});
